import type { ConversationOpenReason } from "../types";
import type { AppIconName } from "@/components/common/app-icon";

import { AI_ASSISTANT } from "@/config/constants";

/**
 * Report-only label copy. The origin vocabulary itself is not redeclared here -
 * it is re-exported from the contact constants so the report, the filter
 * builder and the contact detail all read an origin the same way.
 */
export { getOriginLabel } from "@/features/contact/constants/origin";

export const CLINIC_SYSTEM_FALLBACK = "EMR";

export const OPEN_REASON_LABEL: Record<ConversationOpenReason, string> = {
  new_message: "Contact wrote in",
  form_submission: "Form submitted",
  team_member: "Opened by a team member",
  workflow: "Workflows",
  ai: "Opened by AI",
  follow_up: "Follow-up came due",
  api: "API",
  sync: "Synced from WhatsApp",
};

export const OPEN_REASON_ICON: Record<ConversationOpenReason, AppIconName> = {
  new_message: "solar:chat-round-line-linear",
  form_submission: "solar:clipboard-text-linear",
  team_member: "solar:user-linear",
  workflow: "solar:routing-2-linear",
  ai: AI_ASSISTANT.icon,
  follow_up: "solar:bell-linear",
  api: "solar:plug-circle-linear",
  sync: "solar:history-linear",
};

export const AD_SOURCE_ICON = "mdi:bullhorn-outline";
export const UNKNOWN_SOURCE_ICON = "solar:question-circle-linear";

export const CONVERSATION_OPEN_REASON_OPTIONS: {
  value: ConversationOpenReason;
  label: string;
}[] = Object.entries(OPEN_REASON_LABEL)
  // History sync writes its rows already closed, so no open trigger can match one.
  .filter(([value]) => value !== "sync")
  .map(([value, label]) => ({
    value: value as ConversationOpenReason,
    label,
  }));
